module.exports = __webpack_public_path__ + "img/doctorshelp.f795781d.png";